import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { contractingActivityKeys } from "@/lib/query-keys";
import type { TeamActivityEntry } from "@/types/domain";

/**
 * Últimos movimientos del equipo. `scope: "mine"` los acota a los del propio
 * usuario, que es lo que ve el comercial en "Mi actividad".
 */
export function useTeamActivity(scope: "team" | "mine", enabled = true) {
  return useQuery({
    queryKey: contractingActivityKeys.feed(scope),
    enabled,
    queryFn: () =>
      fetchToBackend<TeamActivityEntry[]>(
        `/contractingactivity${scope === "mine" ? "?scope=mine" : ""}`,
      ),
  });
}
